import { GridRow, gridRowProps } from '@camelot/core';
import { GraphSchema } from '@camelot/server';

export interface InvoiceGridRow extends GridRow {
  accountNumber: string | null;
  analyticalAccount: string | null;
  appliedFromDeposit: boolean | null;
  vatLevelId: number | null;
}

const props: (keyof InvoiceGridRow)[] = ['accountNumber', 'analyticalAccount', 'appliedFromDeposit', 'vatLevelId'];

export const invoiceGridRowProps = new GraphSchema<InvoiceGridRow>(props.concat(gridRowProps));
